<template>
  <div class="tag-template-edit">
    <div class="d-flex">
      {{title}}标签模板
    </div>
    <el-divider></el-divider>
    <div class="d-flex top">
      <div class="f1 mr20">
        <!-- 模板尺寸 -->
        <div>
          <p class="sub-title mb10">
            模板尺寸
          </p>
          <el-select
            class="input200"
            v-model="sizeValue"
            @change="sizeValueChange"
          >
          <el-option
            v-for="item in sizeOptions"
            :key="item.id"
            :label="`${item.name}（${item.remark || `实际尺寸`} mm）`"
            :value="item.value">
          </el-option>
        </el-select>
        </div>
        <el-divider></el-divider>
        <!-- 标签信息 -->
        <p class="sub-title mb10">
        标签信息
        </p>
        <keys
          :mode="'design'"
          :item-index="itemIndex"
          @add="getAddKey"
          @toggleActiveKey="toggleActiveKey"
        />
      </div>
      <!-- 标签设计预览 -->
      <div class="f1">
        <p class="sub-title mb10">
          标签设计预览
        </p>
        <div class="d-flex between mb40">
          <div class="d-flex">
            <div class="d-flex">
              <label class="required">标签名称:</label>
              <el-input
                class="input200 ml5 custom-input"
                v-model="name"
                :placeholder="`请输入`"
              ></el-input>
            </div>

            <div v-if="user.is_super_tenant_admin" class="d-flex ml10">
              <label class="mr10">租户名称：</label>
              <tenantSelection @clickTenant="getTenantInfo" :data="tenantData" @inputClear="inputClear"></tenantSelection>
              <!-- <el-cascader
            :before-filter="remoteSearch"
            filterable
            :options="address"
            clearable
            :show-all-levels="false"
            v-model="tenant_id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader> -->
              <!-- <el-select
                :disabled="$route.params.id != 0"
                :placeholder="`无`"
                class="input200"
                v-model="tenant_id"
                remote
                filterable
                clearable
                :remote-method="getTenantsOpts"
                @focus="getTenantsOpts()"
              >
                <el-option
                  v-for="item in tenantOpts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select> -->
            </div>
          </div>

          <el-button
            type="success"
            size="big"
            class="max-btn ml10"
            @click="saveTemplate"
          >保存为模板</el-button>
        </div>
        <designer
          :mode="'design'"
          :in-list="inList"
          :size="designerSize"
          @removeItem="removeItem"
          :active-key="activeKey"
        />
      </div>
    </div>
  </div>
</template>

<script>
import tenantSelection from '@/components/common/tenantSelection'
import { mapGetters } from 'vuex'
import Keys from '../components/keys.vue'
import Designer from '../components/designer.vue'
import tagMixin from '@/mixins/tag'
import KeysMixin from '../mixins/keys'
import {
  tagManage,
  getSetedTemplate,
  getTenantOpts,
  tagTemplateEdit
} from '@/api.js'
export default {
  name: 'TagTemplateEdit',
  mixins: [ tagMixin, KeysMixin ],
  components: {
    Keys,
    Designer,
    tenantSelection
  },
  computed: {
    ...mapGetters(['user','addressOptions']),
    title() {
      const { id } = this.$route.params
      if (id == 0) {
        return `创建`
      } else {
        return `更新`
      }
    },
    address(){
      // 区县下一级列表初始化
      let arr = this.$utils.deepCopy(this.addressOptions)
                  // 避免重复做处理
                  for (const item of arr) {
        item.code = item.code + 'code'
      }
      for (const province of arr) {
        for (const city of province.children) {
          for (const county of city.children) {
            this.$set(county,'children',[])
          }
        }
      }
      this.tenantOpts.forEach(item => {
        const province = arr.find(i => i.code === item.province + 'code')
        if (province) {
          const city = province.children.find(i => i.code === item.city)
          if (city) {
            const county = city.children.find(i => i.code === item.area)
            if (county) {
              county.children.push({
                name: item.name,
                code: item.id
              })
            }
          }
        }
      })
      return arr
    }
  },
  data() {
    return {
      size: '',
      sizeValue: undefined,
      sizeRemark: undefined,
      sizeOptions: [],
      designerSize: undefined,
      inList: [],
      itemIndex: 0,
      name: '',
      activeKey: '',
      tenantOpts: [],
      tenant_id: undefined,
      tenantData:{
        inputData:'',
        clearable:true,
        status:1
      },
    }
  },
  methods: {
    // 从子组件获取信息
    getTenantInfo(data){
      this.tenant_id = data.id
      this.tenantData.inputData = data.name
    },
    // 当子组件清除内容时
    inputClear(){
      this.tenant_id = ''
    },
    sizeValueChange() {
      const sizeItem = this.sizeOptions.filter(i => i.value === this.sizeValue)[0]
      this.size = sizeItem.name
      this.sizeRemark = sizeItem.remark || undefined
      this.sizeChange()
      this.getTemplateFile(this.sizeValue)
    },
    sizeChange() {
      // 标签工具尺寸切换
      const size = this.size.toLowerCase()
      const sizeArray = size.split('x').map(i => i.trim())
      const width = sizeArray[0] ? Number(sizeArray[0]) : 500
      const height = sizeArray[1] ? Number(sizeArray[1]) : 300
      const sizeConfig = {
        width,
        height,
        scale: 1
      }

      this.designerSize = sizeConfig
    },
    getTenantsOpts(name = null , area = null , province = null , city = null) {
      return this.$request('get', getTenantOpts, { name,province,city,area,status:1  })
      .then(res => {
        this.tenantOpts = res || []
      })
    },
    getTemplateFile(value) {
      // 通过字典value获取预置文件
      this.$request('get', getSetedTemplate, { name: `${value}` })
      .then(async (res) => {
        if (res && res.content) {
          if (this.inList.length) {
            const c = await this.$utils.confirm({ msg: `当前模板已存在内容，是否覆盖？` })
            if (c) {
              this.setInListByTemplate(res.content)
            }
          } else {
            this.setInListByTemplate(res.content)
          }
        }
      })
    },
    setInListByTemplate(content) {
      try {
        const contentData = JSON.parse(content)
        const {
          content: contentString
        } = contentData
        const list = JSON.parse(contentString)

        this.inList = list
        this.itemIndex = this.calcItemIndex(this.inList.length)
      } catch (error) {
        console.error('解析模板出错')
      }
    },
    getAddKey(item) {
      this.inList.push(item)
      this.itemIndex += 1
    },
    async getDetail(id) {
      // 获取详情
      const detail = await this._getSmartTagDetail(id)
      if (detail) {
        const { content, size, name, tenant_id } = detail
        // 因为请求的数据里没有租户名称这个字段，所以需要找出来，然后传递给选择租户的这个组件
        let obj = this.tenantOpts.find(item=>item.id == tenant_id)
        if(obj){
          this.tenantData.inputData = obj.name
        }
        this.size = size
        const arr = this.sizeOptions.filter(i => i.name === size)
        this.sizeValue = arr.length ? arr[0]['value'] : ''
        this.name = name
        this.tenant_id = tenant_id
        this.sizeChange()

        try {
          const tagContent = JSON.parse(content || '[]')
          this.inList = tagContent
          this.itemIndex = this.calcItemIndex(this.inList.length)
        } catch (error) {
          console.error('解析标签数据格式出错')
        }
      }
    },
    calcItemIndex(index = 0) {
      // 计算已添加元素的index，防止重复
      const indexes = this.inList.map(i => i.id).map(i => i.split('-')[0])
      const result = index + 1

      if (indexes.includes(`${result}`)) {
        return this.calcItemIndex(result)
      } else {
        return result 
      }
    },
    init() {
      const { id } = this.$route.params
      if (Number(id)) {
        this.getTenantsOpts()
        this.getDetail(id)
      } else {
        if (!this.sizeOptions.length) {
          this.$message.error(`请先完成可选尺寸配置`)
        }
      }
    },
    removeItem(id) {
      if (!id) return
      
      const list = this.inList.filter(i => i.id !== id)
      this.inList = list
    },
    toggleActiveKey(activeKey) {
      this.activeKey = activeKey
    },
    requiredValidate() {
      // 必填校验
      let validate = true
      const requiredKeys = this.allKeys.filter(i => i.required)
      const inListKeys = this.inList.map(i => i.key)
      const notConfigedKeys = requiredKeys.filter(i => !inListKeys.includes(i.apiKey))
      let illegalKeys = []
      if (notConfigedKeys.length) {
        validate = false
        illegalKeys = illegalKeys.concat(notConfigedKeys.map(i => i.title))
      }

      if (!this.name.trim()) {
        illegalKeys.push(`名称`)
        validate = false
      }

      if (illegalKeys.length) {
        this.$message.error(`${illegalKeys.join('、')}是必填的`)
      }

      return validate
    },
    saveTemplate() {
      // 保存模版文件
      // const validate = this.requiredValidate()
      // if (!validate) return

      const { id } = this.$route.params
      const { name } = this
      const tagId = Number(id)

      if (!this.inList || !this.inList.length) {
        // 内容为空
        this.$message.error(`内容为空`)
        
        return
      }

      if (!name) {
        this.$message.error(`名称不能为空`)

        return
      }

      try {
        // 判断是否有标签识别码
        this.labelIdenCode()
        const content = JSON.stringify(this.inList)
        const params = {
          content,
          name: this.name,
          remark: '',
          status: 0,
          size: this.size,
          size_alias: this.sizeRemark
        }
        
        let url = tagManage
        if (tagId) {
          params.id = tagId
          url = tagTemplateEdit
        } else {
          params.tenant_id = this.tenant_id || undefined
        }

        this.$request('post', url, params)
        .then(res => {
          if (res) {
            // 保存成功
            this.$message.success(`保存成功`)

            this.$router.back()
          }
        })
      } catch (error) {
        // 标签内容转换出错
        console.log(`标签内容转换出错`, JSON.stringify(error))
      }
    },
    labelIdenCode(){ // 如果有标签识别码，需要把当前的标签识别码保存留作历史
      this.inList.forEach(item=>{
        if(item.key == 'labelIdenCode'){
          const configedIdentCodeKeys = this.inList.filter(i => this.tabIdenCode.includes(i.key))
          item.labelIdenCode = configedIdentCodeKeys.map(i => i.key).join('/')
        }
      })
    },
    getDicts() {
      return this.$utils.getDict([604])
      .then(res => {
        if (res) {
          this.sizeOptions = res[604]
        }
      })
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value,status:1  })
      this.tenantOpts = res || []
    },
    expandChange(node){
      if (node[2]) {
        this.getTenantsOpts(null,node[2])
      }
    }
  },
  async created() {
    await this.getDicts()
    this.init()
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/css/common.scss';
  .sub-title {
    font-size: 20px;
    color: $main_color_deep;
  }

</style>